import { LogLevel, PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from '@environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.cognito.authority,
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    clientId: environment.cognito.clientId,
    scope: 'openid profile email masterdata.honkajokioy.fi/read masterdata.honkajokioy.fi/write',
    responseType: 'code',
    logLevel: environment.useO365 ? LogLevel.Warn : LogLevel.Debug, // Less verbose logging in production
    silentRenew: true,
    useRefreshToken: true,
    allowUnsafeReuseRefreshToken: true, // Cognito doesn't support refresh token rotation
    renewTimeBeforeTokenExpiresInSeconds: 30,
    secureRoutes: ['/api/'],
    postLoginRoute: '/app',
    // Disables the auth_time validation for id_tokens in a refresh due to Microsoft Azure's incorrect implementation
    disableRefreshIdTokenAuthTimeValidation: true,
    // For production: automatically route to O365 via Cognito federated identity
    // For dev/staging: use regular Cognito authentication
    ...(environment.useO365 && {
      customParamsAuthRequest: {
        identity_provider: 'HonkajokiO365'
      }
    })
  }
};
